import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MaterialFolderGrid from "../components/MaterialFolderGrid";
import { getAllTopics } from "../helper/apicalls/topic";
import { getQuestionBankFolders, getQuestionBankInstitutionFolders } from "../helper/apicalls/questionBank";
import "../styles/MaterialFolder.scss";

const QuestionBankSubject = () => {
  const { coursekey, subjectkey } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "course";
  const [activeTab, setActiveTab] = useState(initialTab);

  const [courseFolders, setCourseFolders] = useState([]);
  const [institutionFolders, setInstitutionFolders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [topicsRes, foldersRes, instFoldersRes] = await Promise.all([
          getAllTopics(subjectkey),
          getQuestionBankFolders({ title: "subject", key: subjectkey || "" }),
          getQuestionBankInstitutionFolders({ title: "subject", key: subjectkey || "" }),
        ]);

        const topics = Array.isArray(topicsRes) ? topicsRes : [];
        const qbFolders = Array.isArray(foldersRes?.data)
          ? foldersRes.data
          : Array.isArray(foldersRes)
          ? foldersRes
          : [];
        const instQbFolders = Array.isArray(instFoldersRes?.data)
          ? instFoldersRes.data
          : Array.isArray(instFoldersRes)
          ? instFoldersRes
          : [];

        const topicFolders = topics.map((t) => ({ ...t, _kind: "topic" }));
        const materialFolders = qbFolders.map((f) => ({
          ...f,
          _kind: "material",
        }));
        const instMaterialFolders = instQbFolders.map((f) => ({
          ...f,
          _kind: "institution_material",
        }));

        setCourseFolders([...topicFolders, ...materialFolders]);
        setInstitutionFolders([...topicFolders, ...instMaterialFolders]);
      } catch (e) {
        console.error("Failed to load question banks for subject", e);
        setCourseFolders([]);
        setInstitutionFolders([]);
      } finally {
        setLoading(false);
      }
    };

    if (subjectkey) {
      fetchData();
    }
  }, [subjectkey]);

  const handleOpenFolder = (folder) => {
    if (!folder) return;
    if (folder._kind === "topic" && folder.key) {
      navigate(`/question-bank/${coursekey}/${subjectkey}/${folder.key}?tab=${activeTab}`);
      return;
    }
    if (folder._kind === "material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/question-bank-folder/${folderId}`);
      return;
    }
    if (folder._kind === "institution_material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/question-bank-folder/${folderId}?type=institution`);
      return;
    }
  };

  const currentFolders = activeTab === "institution" ? institutionFolders : courseFolders;

  return (
    <div className="materials-page">
      <div className="materials-header">
        <h1 className="materials-title">Question Bank - Topics</h1>
      </div>

      <div className="materials-tabs">
        <button
          type="button"
          className={`materials-tab ${activeTab === "course" ? "active" : ""}`}
          onClick={() => setActiveTab("course")}
        >
          Course Resources
        </button>
        <button
          type="button"
          className={`materials-tab ${activeTab === "institution" ? "active" : ""}`}
          onClick={() => setActiveTab("institution")}
        >
          Institution Resources
        </button>
      </div>

      {loading ? (
        <div className="materials-loading">Loading question banks...</div>
      ) : (
        <MaterialFolderGrid folders={currentFolders} onOpen={handleOpenFolder} />
      )}
    </div>
  );
};

export default QuestionBankSubject;
